/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectDeliverableInvoiceResource } from './';
import {
    ProjectDeliverableInvoiceResourceFromJSON,
    ProjectDeliverableInvoiceResourceFromJSONTyped,
    ProjectDeliverableInvoiceResourceToJSON,
} from './';
import type { ProjectDeliverablePaymentResource } from './';
import {
    ProjectDeliverablePaymentResourceFromJSON,
    ProjectDeliverablePaymentResourceFromJSONTyped,
    ProjectDeliverablePaymentResourceToJSON,
} from './';
import type { ProjectDeliverableResource } from './';
import {
    ProjectDeliverableResourceFromJSON,
    ProjectDeliverableResourceFromJSONTyped,
    ProjectDeliverableResourceToJSON,
} from './';
import type { ProjectDeliverableType } from './';
import {
    ProjectDeliverableTypeFromJSON,
    ProjectDeliverableTypeFromJSONTyped,
    ProjectDeliverableTypeToJSON,
} from './';
import type { WorkedUnit } from './';
import {
    WorkedUnitFromJSON,
    WorkedUnitFromJSONTyped,
    WorkedUnitToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectLotDeliverableResource
 */
export interface ProjectLotDeliverableResource extends ProjectDeliverableResource {
    /**
     * 
     * @type {number}
     * @memberof ProjectLotDeliverableResource
     */
    month: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectLotDeliverableResource
     */
    workAmount?: number;
    /**
     * 
     * @type {WorkedUnit}
     * @memberof ProjectLotDeliverableResource
     */
    workedUnit?: WorkedUnit;
}

/**
 * Check if a given object implements the ProjectLotDeliverableResource interface.
 */
export function instanceOfProjectLotDeliverableResource(value: object): value is ProjectLotDeliverableResource {
    if (!('month' in value) || value['month'] === undefined) return false;
    return true;
}

export function ProjectLotDeliverableResourceFromJSON(json: any): ProjectLotDeliverableResource {
    return ProjectLotDeliverableResourceFromJSONTyped(json, false);
}

export function ProjectLotDeliverableResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectLotDeliverableResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDeliverableResourceFromJSONTyped(json, ignoreDiscriminator),
        'month': json['month'],
        'workAmount': json['workAmount'] == null ? undefined : json['workAmount'],
        'workedUnit': json['workedUnit'] == null ? undefined : WorkedUnitFromJSON(json['workedUnit']),
    };
}

export function ProjectLotDeliverableResourceToJSON(value?: ProjectLotDeliverableResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDeliverableResourceToJSON(value, true),
        'month': value['month'],
        'workAmount': value['workAmount'],
        'workedUnit': WorkedUnitToJSON(value['workedUnit']),
    };
}

